import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./forgotpassword.scss";
import { TextField } from '@mui/material';
import { forgotPassword } from "../../Api";
import Swal from 'sweetalert2';

function ForgotPassword() {
    const navigate = useNavigate();
  const [email, setEmail] = useState("");


  const submit = async () => {
    Swal.fire({
      html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
      showConfirmButton: false,
      heightAuto: false,
      customClass: { popup: "loader-swal" },
    });
    let formData = { email: email.toLowerCase() };
    let emalval = new RegExp(
      "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
    );
    if (!formData.email) {
      Swal.fire({
        text: "Email required!",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
    } else if (!emalval.test(formData.email)) {
      Swal.fire({
        text: "Please enter valid Email",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
    } else if (email.length > 255) {
      Swal.fire({
        text: "Email address should be less than 255 characters",
        icon: "warning",
        showConfirmButton: false,
        heightAuto: false,
        timer: 1500,
      });
    } else {
      let resData = await forgotPassword(formData);
      Swal.fire({
        html: `<img src=${require("../../assets/loader.gif")} style="width: 50px" alt="loader">`,
        showConfirmButton: false,
        heightAuto: false,
        customClass: { popup: "loader-swal" },
        timer: 2000,
      });
      if (resData.status === "S") {
        Swal.fire({
          text: "You will receive an email shortly, Redirecting to Login!",
          showConfirmButton: false,
          icon: "success",
          timer: 3000,
        }).then(() => {
          navigate("/login");
        });
      } else if (resData.status === "E" && resData.result_code === 404) {
        Swal.fire({
          text: "Invalid Email",
          showConfirmButton: false,
          icon: "warning",
          timer: 3000,
        });
        return;
      } else {
        Swal.fire({
          text: JSON.stringify(resData),
          showConfirmButton: false,
          icon: "warning",
          timer: 3000,
        });
        return;
      }
    }
  };


    //}

    return (
      <div className="loginContainer forgot-screen">
        <div className="row g-0 h-100 w-100">
          <div className="col-6">
            <div className="loginLeft d-none d-lg-flex">
              <h2 className="headingText">
              <strong>Welcome to <span className="color-text">PRISM</span> </strong>
            </h2>
            <img
              src={require("../../assets/image.png")}
              alt="UpwardiqPrism"
              className="vec-image"
            />
            <h5 className="mt-3">
              Performance Review & Insights for Sanctions Model
            </h5>
            </div>
          </div>
          <div className="col-12 col-lg-6 h-100">
            <div className="loginRight h-100">
              <h5 className="loginText text-white">Forgot Password</h5>
              <p className="text-white forgot-subtext">Enter your Registered Email</p>
              <TextField
                id="outlined-basic"
                label="Email "
                variant="outlined"
                className="mb-3 cust-white-input-field w-100 "
                autoComplete="off"
                inputProps={{
                  maxLength: 255,
                }}
                value={email}
                onChange={(ev) => {
                  const input = ev.target.value;
                  // Regular expression to block specific patterns
                  const disallowedPattern =
                    /<script.*?>.*?<\/script>|<.*?>|[<>/:?[\]\\|""'',; ]/i;

                  // Allow input only if it doesn't match the pattern
                  if (!disallowedPattern.test(input)) {
                    setEmail(input);
                  }
                }}
                onKeyDown={(ev) => {
                  if (ev.key === "Enter") {
                    ev.preventDefault();
                    submit();
                  }
                }}
              />
              
              <div className="text-center">
                <button
                  className="btn btn-white rounded-pill text-uppercase"
                  onClick={() => {
                    submit();
                  }}
                >
                  Send
                </button>
              </div>
              <div className="text-center mt-3 text-white">
                <p>
                  Remember password ?{" "}
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      navigate("/login");
                    }}
                  >
                    Login
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default ForgotPassword
